module.exports = __webpack_public_path__ + "img/y-45.7ed37445.png";